import { render, staticRenderFns } from "./plant-selector.vue?vue&type=template&id=4a02f46f"
import script from "./plant-selector.ts?vue&type=script&lang=ts&external"
export * from "./plant-selector.ts?vue&type=script&lang=ts&external"
import style0 from "./plant-selector.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a02f46f')) {
      api.createRecord('4a02f46f', component.options)
    } else {
      api.reload('4a02f46f', component.options)
    }
    module.hot.accept("./plant-selector.vue?vue&type=template&id=4a02f46f", function () {
      api.rerender('4a02f46f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plant-selector/plant-selector.vue"
export default component.exports